// extracted by mini-css-extract-plugin
module.exports = {"btnaddfocus":"index_btnaddfocus_vE12X","header":"index_header_3jiyC"};